import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import {
  GET_ORDER,
  GET_ORDER_SUMMARY,
  GET_ORDER_SUMMARY_CONFIRMATION,
  COMPLETE_ADDITIONAL_STEPS_AFTER_PAYMENT,
  UPDATE_ORDER,
} from "../actions";

import {
  getOrderSuccess,
  getOrderError,
  getOrderSummarySuccess,
  getOrderSummaryError,
  getOrderConfirmationSuccess,
  getOrderConfirmationError,
  completeAdditionalStepsAfterPaymentSuccess,
  updateOrderSuccess,
  updateOrderError,
  completeAdditionalStepsAfterPaymentError
} from "./actions";
import { getActivityHeadersUpdated } from "../../utils/parentChildActivities";

const CompleteAdditionalStepsError = "Complete additional steps fails";

export function* watchUpdateOrder() {
  yield takeEvery(UPDATE_ORDER, updateOrder);
}

export function* watchGetOrder() {
  yield takeEvery(GET_ORDER, getOrder);
}

export function* watchGetOrderSummary() {
  yield takeEvery(GET_ORDER_SUMMARY, getOrderSummary);
}

export function* watchGetOrder1Confirmation() {
  yield takeEvery(GET_ORDER_SUMMARY_CONFIRMATION, getOrderConfirmation);
}


export function* watchCompleteAdditionalStepsAfterPayment() {
  yield takeEvery(COMPLETE_ADDITIONAL_STEPS_AFTER_PAYMENT, completeAdditionalStepsAfterPayment);
}

const getOrderAsync = async (payload) => {
  try {

    const orderReturned = await centralApiAxios.get(
      `/Orders/${payload.orderId}`
    );


    if (orderReturned.data) {
      return {
        order: orderReturned.data,
        message: null,
      };
    }

    return { message: "Get Order info failed." };
  } catch (error) {
    return {
      message: "Failed to get Order. ",
    };
  }
};

const getOrderConfirmationSummaryAsync = async (payload) => {
  try {

    const responseObject = await centralApiAxios.get(`/orders/confirmation/${payload.orderId}?id=${payload.orderId}&lcid=1033&invoice_id=${payload.invoiceId}`, getActivityHeadersUpdated(payload));

    return {
      orderConfirmation: responseObject.data,
      message: null,
    };

  } catch (error) {
    return {
      message: "Failed to get Order. ",
    };
  }
};

const getOrderSummaryAsync = async (payload) => {
  try {
    const responseObject = await centralApiAxios.get(`/orders/summary/${payload.orderId}?lcid=1033`, getActivityHeadersUpdated(payload));

    return {
      orderSummary: responseObject.data,
      message: null,
    };

  } catch (error) {
    return {
      message: "Failed to get Order. ",
    };
  }
};

const updateOrderAsync = async (payload) => {
  try {
    const responseObject = await centralApiAxios.put("orders?id=" + payload.order.orderId, payload.order, getActivityHeadersUpdated(payload));

    return {
      order: responseObject.data,
      message: null,
    };

  } catch (error) {
    return {
      message: "Failed to get Order. ",
    };
  }
};

function* updateOrder({ payload }) {
  try {
    const returnedData = yield call(updateOrderAsync, payload);
    if (!returnedData.message) {
      yield put(
        updateOrderSuccess({
          order: returnedData.order
        })
      );
    } else {
      yield put(updateOrderError(returnedData.message));
    }
  } catch (error) {
    yield put(updateOrderError(error));
  }
}

function* getOrder({ payload }) {
  try {
    const returnedData = yield call(getOrderAsync, payload);
    if (!returnedData.message) {
      yield put(
        getOrderSuccess({
          order: returnedData.order
        })
      );
    } else {
      yield put(getOrderError(returnedData.message));
    }
  } catch (error) {
    yield put(getOrderError(error));
  }
}

function* getOrderSummary({ payload }) {

  if (payload.isSagaExecuted) {
    yield put(getOrderSummaryError("saga called"));
  }
  else {
    if (!payload.isSagaExecuted) {
      payload.isSagaExecuted = true;
    }

    try {
      const returnedData = yield call(getOrderSummaryAsync, payload);

      if (!returnedData.message) {
        yield put(getOrderSummarySuccess(returnedData));
      } else {
        yield put(getOrderSummaryError(returnedData.message));
      }
    } catch (error) {
      yield put(getOrderSummaryError(error));
    }
  }
}

function* getOrderConfirmation({ payload }) {
  try {
    const returnedData = yield call(getOrderConfirmationSummaryAsync, payload);
    if (!returnedData.message) {
      yield put(getOrderConfirmationSuccess(returnedData.orderConfirmation));
    } else {
      yield put(getOrderConfirmationError(returnedData.message));
    }
  } catch (error) {
    yield put(getOrderConfirmationError(error));
  }
}

const completeAdditionalStepsAfterPaymentAsync = async (payload) => {
  try {
    const dataReturned = await centralApiAxios.get(
      `orders/complete_additional_steps/${payload.orderId}?invoice_id=${payload.invoiceId}`
    );
    if (dataReturned.data) {
      return {
        completionStatusOfAdditionalSteps: dataReturned.data,
        message: null,
      };
    }
    return { message: CompleteAdditionalStepsError };
  } catch (error) {
    return {
      message: CompleteAdditionalStepsError,
    };
  }
};

function* completeAdditionalStepsAfterPayment({ payload }) {
  try {
    const returnedData = yield call(completeAdditionalStepsAfterPaymentAsync, payload);
    if (!returnedData.message) {
      yield put(completeAdditionalStepsAfterPaymentSuccess(returnedData));
    } else {
      yield put(completeAdditionalStepsAfterPaymentError(returnedData.message));
    }
  } catch (error) {
    yield put(completeAdditionalStepsAfterPaymentError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchGetOrder),
    fork(watchGetOrderSummary),
    fork(watchGetOrder1Confirmation),
    fork(watchUpdateOrder),
    fork(watchCompleteAdditionalStepsAfterPayment)
  ]);
}